import React from 'react'
import AppealTable from './AppealTable'

function Declined({globalReset,filterIntake,filterLearningMethod,filterSchool,filterLecturer}) {
  return <AppealTable globalReset={globalReset} filterIntake={filterIntake} filterLearningMethod={filterLearningMethod} filterSchool={filterSchool} filterLecturer={filterLecturer}/>
}

export default Declined